export default __webpack_public_path__ + "static/media/non_actif_masque.4f31dea4.svg";